/**
 * Master switch for every "out of scope" indication on time entry.
 *
 * OFF: the feature is not released. While it is off, nothing tells a user that
 * an activity or an engagement is out of scope —
 *   - the activity picker's "Out of scope" badge and its In scope / Out of
 *     scope sections (week grid, day view, timer);
 *   - the engagement line's amber tint, its "does not list this activity"
 *     tooltip and its screen-reader "(out of scope)" marker (week grid, day
 *     view, approvals, timer);
 *   - the "out of scope" tag on an engagement in the "Which engagement?"
 *     dialog.
 *
 * What stays is behaviour, not labelling: an entry can still be attributed to
 * an engagement that does not list its activity, and it is stored and
 * submitted as before. It just reads like any other attribution.
 *
 * Flip to `true` to release all of it at once. Every surface reads this one
 * constant so they cannot drift apart again.
 */
export const SHOW_OUT_OF_SCOPE = false;
